import {
  __decorateClass
} from "./chunk.WHWUXFA2.js";

// src/components/jb-ref-key-figures/jb-ref-key-figures.ts
import { JbKeyFigures } from "@bjb/bjb-web-components/dist/components/jb-key-figures/jb-key-figures";
import { html, nothing, unsafeCSS } from "lit";
import { customElement } from "lit/decorators.js";

// src/components/jb-ref-key-figures/jb-ref-key-figures.scss?inline
import { css } from "lit-element/lit-element.js";
var jb_ref_key_figures_default = css`/* COLOR SETTINGS */
/* shadows */
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
h2, .figure-wrap, .info-wrap {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

h2 {
  font-size: var(--theme-typo-h2-section-title-mobile-fontsize, 1.5rem);
  font-weight: var(--theme-typo-h2-section-title-fontweight, var(--theme-font-light-weight, 300));
  letter-spacing: var(--theme-typo-h2-section-title-mobile-letterspacing, 0.125rem);
  line-height: var(--theme-typo-h2-section-title-mobile-lineheight, 2.25rem);
}

@media (min-width: 1281px) {
  h2 {
    font-size: var(--theme-typo-h2-section-title-desktop-fontsize, 1.938rem);
    letter-spacing: var(--theme-typo-h2-section-title-desktop-letterspacing, 0.25rem);
    line-height: var(--theme-typo-h2-section-title-desktop-lineheight, 2.5rem);
  }
}
.figure-wrap {
  font-size: var(--theme-typo-h2-subtitle-mobile-fontsize, 1.625rem);
  font-weight: var(--theme-typo-h2-subtitle-fontweight, var(--theme-font-light-weight, 300));
  line-height: var(--theme-typo-h2-subtitle-mobile-lineheight, 2.188rem);
}

@media (min-width: 1281px) {
  .figure-wrap {
    font-size: var(--theme-typo-h2-subtitle-desktop-fontsize, 1.938rem);
    line-height: var(--theme-typo-h2-subtitle-desktop-lineheight, 2.625rem);
  }
}
.info-wrap {
  font-size: var(--theme-typo-p-small-desktop-fontsize, 1rem);
  font-weight: var(--theme-typo-p-small-fontweight, var(--theme-font-light-weight, 300));
  line-height: var(--theme-typo-p-small-desktop-lineheight, 1.625rem);
}

.sr-only {
  block-size: 1px;
  border: 0;
  clip: rect(0, 0, 0, 0);
  inline-size: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
}

h2 {
  text-align: center;
  text-transform: uppercase;
}

h2 + .figures {
  margin-top: var(--theme-spacing-l);
}

.figures {
  column-gap: 40px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  row-gap: var(--theme-spacing-l);
}

.figure {
  align-items: center;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-block: var(--theme-spacing-lm);
  padding-inline: var(--theme-spacing-xs);
  width: 100%;
}
@media (min-width: 960px) {
  .figure {
    padding-block: var(--theme-spacing-m);
    --12-cols-width: 100%;
    --11-gaps-width: 440px;
    --1-col-width: calc((var(--12-cols-width) - var(--11-gaps-width)) / 12);
    width: calc(var(--1-col-width) * 5 + 160px);
  }
}
@media (min-width: 1281px) {
  .figure {
    width: calc(var(--1-col-width) * 4 + 120px);
  }
}
@media (min-width: 1437px) {
  .figure {
    width: calc(var(--1-col-width) * 10 / 3 + 80px);
  }
}

.figure-wrap {
  text-align: center;
}

.info-wrap {
  text-align: center;
}`;

// src/components/jb-ref-key-figures/jb-ref-key-figures.ts
var JbRefKeyFigures = class extends JbKeyFigures {
  _getContentSpacingProperties() {
    return { grid: true, colsMdUp: 12, type: "no-vertical-space" };
  }
  render() {
    return html`
      <section>
        ${this.headline && html`<h2>${this.headline}</h2>`}
        <div class="figures">
          ${this.figures.map(
      (figure) => html`
              <div class="figure">
                ${figure.infoOne ? html` <div class="figure-wrap">${figure.infoOne}</div> ` : nothing}
                ${figure.infoTwo ? html` <div class="info-wrap">${figure.infoTwo}</div> ` : nothing}
              </div>
            `
    )}
        </div>
      </section>
    `;
  }
};
JbRefKeyFigures.styles = [unsafeCSS(jb_ref_key_figures_default)];
JbRefKeyFigures = __decorateClass([
  customElement("jb-ref-key-figures")
], JbRefKeyFigures);

export {
  JbRefKeyFigures
};
